import formatXml from "xml-formatter";
export function getXMLBeautifyString(_ref) {
  var input = _ref.input,
    selectedSpaces = _ref.selectedSpaces,
    encodingRadio = _ref.encodingRadio;
  var indentation = " ".repeat(selectedSpaces);
  if (encodingRadio === "beautify") {
    return formatXml(input, {
      indentation: indentation,
      collapseContent: true,
      lineSeparator: "\n"
    });
  }
  var minifiedXML = formatXml.minify(input, {
    filter: function filter(node) {
      return node.type !== "Comment";
    },
    collapseContent: true
  });
  return minifiedXML;
}